import React, { useEffect, useContext } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import awsExports from "../aws-exports";
import { Amplify, I18n } from "aws-amplify";
import ability from "../context/casl/ability";
import { AbilityContext } from "../context/casl/abilityContext";
import { UpdateAbility } from "../context/casl/abilityLoader";
import DmNavbarContext from "@app/context/dmNavbarContext";
import Navbar from "./modules/navbar.component";
import vocabularies from "@app/translations/vocabularies.json";
import SessionTimeout from "./modules/components/SessionTimeout/SessionTimeout";

I18n.putVocabularies(vocabularies);
Amplify.configure(awsExports);

export default function Root() {
  const [state, dispatch] = useContext(DmNavbarContext);
  const userPermissions =
    JSON.parse(localStorage.getItem("user-profile")).userPermissions || {};

  useEffect(() => {
    if (state.customerCode) {
      UpdateAbility(userPermissions, state.customerCode);
    }
  }, [state.customerCode]);

  return (
    <AbilityContext.Provider value={ability}>
      <Router>
        <Navbar />
        <SessionTimeout/>
      </Router>
    </AbilityContext.Provider>
  );
}
